import { connect } from 'react-redux';
import dashboardLayout from '../components/dashboardLayout/dashboardLayout';
import { openSideBar, closeSideBar } from '../actions/sideBar'

const mapStateToProps = (state) => ({
    data: state.navBarReducer
})

const mapDispatchToProps = (dispatch) => {
    return {
        openSideBar: () => {
            dispatch(openSideBar())
        },
        closeSideBar: () => {
            dispatch(closeSideBar())
        }
    }
}

const DashboardLayout = connect(
    mapStateToProps,
    mapDispatchToProps
)(dashboardLayout)

export default DashboardLayout;